<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-5">
<h1 class="tochead"><span class="bold">Contents</span></h1>
</a><h2 class="toc_chap"><a id="VPS-5"></a><a href="#/xhtml/006_Acknowledgements"><em class="italic">Acknowledgements</em></a></h2>
<h2 class="toc_chap"><a href="#/xhtml/007_Introduction"><em class="italic">Introduction</em></a></h2>
<h2 class="toc_chap1"><a href="#/xhtml/008_Chapter_1"><span class="tochang"><span class="bold">Chapter 1</span></span>The Birth of the <em class="italic">Polis</em> and the Hoplite</a></h2>
<h2 class="toc_chap1"><span href="#/xhtml/009_Chapter_2" title="Link target outside of Sample"><span class="tochang"><span class="bold">Chapter 2</span></span>The Ascendancy of Sparta</span></h2>
<h2 class="toc_chap1"><span href="#/xhtml/010_Chapter_3" title="Link target outside of Sample"><span class="tochang"><span class="bold">Chapter 3</span></span>The Lelantine War and the Rise of Athens</span></h2>
<h2 class="toc_chap1"><span href="#/xhtml/011_Chapter_4" title="Link target outside of Sample"><span class="tochang"><span class="bold">Chapter 4</span></span>The Ionian Revolt and the Greco-Persian Wars</span></h2>
<h2 class="toc_chap1"><span href="#/xhtml/012_Chapter_5" title="Link target outside of Sample"><span class="tochang"><span class="bold">Chapter 5</span></span>The Peloponnesian War and the Corinthian War</span></h2>
<h2 class="toc_chap1"><span href="#/xhtml/013_Chapter_6" title="Link target outside of Sample"><span class="tochang"><span class="bold">Chapter 6</span></span>The Theban-Spartan War and the Rise of Macedonia</span></h2>
<h2 class="toc_chap1"><span href="#/xhtml/014_Chapter_7" title="Link target outside of Sample"><span class="tochang"><span class="bold">Chapter 7</span></span>Troop Types and Organization of the Greek Armies</span></h2>
<h2 class="toc_chap1"><span href="#/xhtml/015_Chapter_8" title="Link target outside of Sample"><span class="tochang"><span class="bold">Chapter 8</span></span>Panoply and Tactics of the Greek Armies</span></h2>
<h2 class="toc_chap11"><span href="#/xhtml/016_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
<h2 class="toc_chap"><span href="#/xhtml/017_BM1" title="Link target outside of Sample"><em class="italic">The Re-enactors who Contributed to this Book</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?d56700ca